import type { TagJSONObject } from '@ikegps/core-api';
import { ImageButton } from '../../components/button/image.button';
import { VerifyIcon } from '../../components/icon/ike';
import { T } from '../../i18n';
import type { MithrilVNode } from '../../mithril';
import { VerifyWorkbenchCtrl } from './verify.workbench.ctrl';

/** Button shown next to a job name (on hover) to open that whole job in Verify. */
function view(job: TagJSONObject): MithrilVNode | null {
	if (!VerifyWorkbenchCtrl.canOpenInVerify(job)) {
		return null;
	}

	return ImageButton.view(VerifyIcon, {
		title: T.OPEN_JOB_IN_VERIFY,
		testId: 'open-job-in-verify',
		onclick: (event) => {
			event.stopPropagation();
			void VerifyWorkbenchCtrl.openJobInVerify(job);
		},
	});
}

export const JobVerifyButton = { view };
